import React from "react";

function Header({ userName = "Admin", onNavigateHome }) {
  const goHome = () => {
    if (typeof onNavigateHome === "function") onNavigateHome();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      goHome();
    }
  };

  return (
    <header className="main-header">
      <div className="header-left">
        <div
          className="brand-home"
          role="button"
          tabIndex={0}
          onClick={goHome}
          onKeyDown={handleKeyDown}
          aria-label="Go to home"
          title="Go to home"
        >
          <div className="logo-container">
            <span className="accenture-logo">&gt;</span>
            <span className="company-name">Accenture</span>
          </div>
          <span className="header-divider">|</span>
          <span className="platform-title">ATC GenAI Store</span>
        </div>
      </div>
      <div className="header-right">
        <span className="user-greeting"><span className="welcome-accent">Welcome</span> {userName}</span>
      </div>
    </header>
  );
}

export default Header;
